import Component from 'inferno-component';
import { connect } from 'inferno-redux';
import { Location } from './Location';
import { fetchFeaturedLocations } from '../../actions/actions';
import { Grid, Divider, Header, Container }     from 'semantic-ui-react';
import { Link } from 'inferno-router';

class FeaturedLocations extends Component {
  componentDidMount() {
    this.props.dispatch(fetchFeaturedLocations());
  }

  render() {
    const availableFeaturedLocations = (this.props.featuredLocations) ? this.props.featuredLocations : [];
    return (
      <Container fluid style={{backgroundColor: '#212121', marginLeft: '0 !important', marginRight: '0 !important;'}}>
        <Container id="hirdetesi-helyszinek" className="smt">
          <Grid relaxed className="fp m-0" stackable verticalAlign='middle'>
            <Grid.Row centered className="m-0">
              <Grid.Column>
                <Divider horizontal><Header as='h3' style={{color: 'white'}}>Hirdetési helyszínek</Header></Divider>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row centered>
              <Grid container stackable verticalAlign='middle'>
                <Grid.Row className="m-0" style={{justifyContent: 'center'}}>
                  {
                    availableFeaturedLocations.map( (location, index) =>
                    <Location location={location} key={index}/> )
                  }
                </Grid.Row>
              </Grid>
            </Grid.Row>

            <Grid.Row centered>
              {
                this.props.showMoreLocations ? <Link to='/hirdetesi-helyszinek' >További helyszínek</Link> : ''
              }
            </Grid.Row>

          </Grid>
        </Container>
      </Container>
    );
  }

}

function mapStateToProps(state) {
  return {
    featuredLocations: state.locations.featuredLocations,
    loadingFeatured: state.locations.loadingFeatured,
    showMoreLocations: state.locations.showMoreLocations
  };
}

export default connect(mapStateToProps)(FeaturedLocations);



// WEBPACK FOOTER //
// ./src/components/locations/FeaturedLocations.js